import React, {useContext, useState} from "react";
import {WorkScheduleContext} from "../context/work-schedule-context.jsx";
import clsx from "clsx";
import '../../../utils/work-schedule.css';

const WorkScheduleDay = ({ completeDate, hasSchedules, intervals }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const { handleDrop, isDragging, setIsDragging } = useContext(WorkScheduleContext);

    const isFilled = (index) => {
        for (let interval of intervals) {
            const { startHour, endHour } = interval;

            if (startHour < endHour) if (index >= startHour && index < endHour) return true;
        }
        return false;
    }

    return (
        <div className={clsx(
            "w-[10%] h-[40px] flex items-center border border-[#ebebeb] box-border",
            {
                "!border-2 border-dashed !border-[#cccccc] justify-center transition-colors duration-300": !hasSchedules && isDragging,
                "bg-[#a8a8ff]": !hasSchedules && isMouseOver,
            })} day={completeDate}
             onDrop={(e) => {
                 handleDrop(e, completeDate);
                 setIsDragging(false)
                 setIsMouseOver(false);
             }}
             onDragOver={(e) => e.preventDefault()}
             onDragEnter={() => setIsMouseOver(true)}
             onDragLeave={() => setIsMouseOver(false)}>
            <div className="dropped-item">
                {
                    intervals &&
                    [...Array(24)].map((p, index) => {
                        return (
                            <div key={index} className={`${index} ${isFilled(index) ? 'filled' : ''}`}></div>
                        )
                    })
                }
                <div className="absolute top-0 flex min-w-[90px]! items-center justify-center">
                  {
                    intervals.map((interval, idx) => (
                      interval.startFormatted  != null && interval.endFormatted != null &&
                      <span key={idx} className="block">{`${interval.startFormatted} - ${interval.endFormatted}`}</span>
                    ))
                  }
                </div>
            </div>
        </div>
    );
};

export default WorkScheduleDay;